<template>
  <v-snackbar
    v-show="showErrorMessage"
    v-model="showErrorMessage"
    color="error"
    multi-line
    bottom
    :timeout="-1"
  >
    <ul>
      {{
        error
      }}
    </ul>
    <v-btn text @click="showErrorMessage = false">{{ 'Cerrar' }}</v-btn>
  </v-snackbar>
</template>

<script>
import * as types from '@/store/mutation-types'

export default {
  name: 'ErrorMessage',
  computed: {
    showErrorMessage: {
      get() {
        return this.$store.state.errors.showErrorMessage
      },
      set(value) {
        this.$store.commit(types.SHOW_ERROR, value)
      }
    },
    error() {
      return this.$store.state.errors.errorMessage
    }
  },
  watch: {
    error() {
      setTimeout(() => {
        this.showErrorMessage = this.error !== null
      }, 100)
    }
  }
}
</script>
